import { getLogger } from '@sas/nova-core/logging';
import { EarconName } from '../types';
import drag from './audio/drag.mp3';
import drillDown from './audio/drillDown.mp3';
import drillUp from './audio/drillUp.mp3';
import drop from './audio/drop.mp3';
import error from './audio/error.mp3';
import inputFull from './audio/inputFull.mp3';
import notification from './audio/notification.mp3';
import popupClose from './audio/popupClose.mp3';
import popupOpen from './audio/popupOpen.mp3';
import processComplete from './audio/processComplete.mp3';
export class Earcon {
  constructor(props) {
    // Need to determine if source is the key of one of our included sounds, or a custom audio source
    switch (props.source) {
      case EarconName.Drag:
        this.audio = new Audio(drag);
        break;
      case EarconName.DrillDown:
        this.audio = new Audio(drillDown);
        break;
      case EarconName.DrillUp:
        this.audio = new Audio(drillUp);
        break;
      case EarconName.Drop:
        this.audio = new Audio(drop);
        break;
      case EarconName.Error:
        this.audio = new Audio(error);
        break;
      case EarconName.InputFull:
        this.audio = new Audio(inputFull);
        break;
      case EarconName.Notification:
        this.audio = new Audio(notification);
        break;
      case EarconName.PopupClose:
        this.audio = new Audio(popupClose);
        break;
      case EarconName.PopupOpen:
        this.audio = new Audio(popupOpen);
        break;
      case EarconName.ProcessComplete:
        this.audio = new Audio(processComplete);
        break;
      default:
        // This source name didn't match any of our sound keys, try and use it as a custom audio source
        if (props.source) {
          this.audio = new Audio(props.source);
        }
        break;
    }

    // This event triggers if the audio we tried to load is invalid
    if (this.audio) {
      this.audio.onerror = () => {
        getLogger('Earcon').error(
        // eslint-disable-next-line @sas/i18n/jsx-to-localize
        `Error loading audio source '${props.source}'. Verify the path is correct.`);
      };
    }
  }

  /** Occurs when playback is possible, but would require further buffering. */
  setOnCanPlay = callback => {
    if (this.audio) {
      this.audio.oncanplay = callback;
    }
  };

  /** Occurs when smooth playback is possible since the browser estimates no more buffering will be needed. */
  setOnCanPlayThrough = callback => {
    if (this.audio) {
      this.audio.oncanplaythrough = callback;
    }
  };

  /** Occurs when there is an error loading or playing the audio */
  setOnError = callback => {
    if (this.audio) {
      this.audio.onerror = callback;
    }
  };

  /** Play the audio clip. If partially played, it will resume playback where it left off. */
  play = () => {
    if (this.audio) {
      this.audio.play();
    }
  };
  pause = () => {
    this.audio?.pause();
  };
  getPaused = () => {
    return this.audio?.paused;
  };
  getDuration = () => {
    return this.audio?.duration;
  };
  getCurrentTime = () => {
    return this.audio?.currentTime;
  };
  setCurrentTime = newTime => {
    if (this.audio) {
      this.audio.currentTime = newTime;
    }
  };

  /** Enable to make the audio clip loop */
  setLoop = loop => {
    if (this.audio) {
      this.audio.loop = loop;
    }
  };

  /** Play the audio clip starting at the beginning */
  playFromStart = () => {
    if (this.audio) {
      this.audio.currentTime = 0;
      this.play();
    }
  };
}
//# sourceMappingURL=Earcon.js.map